import { Tab, TabProps } from 'react-admin';

import { DiagnosticsList } from 'resources/diagnostics/components/DiagnosticsList';

export const DiagnosticsTab = (props: Omit<TabProps, 'children'>) => (
  <Tab {...props}>
    <DiagnosticsList />
  </Tab>
);
